"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BoxTheme = function BoxTheme(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_core.MuiThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_core.CssBaseline, null), children);
};

BoxTheme.propTypes = {
  /** The component that will wrap the App to be themed with the given prop */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element]),

  /** The theme prop to change themes (Light,Dark, Vox) */
  theme: _propTypes.default.object
};
BoxTheme.defaultProps = {
  theme: null,
  children: null
};
var _default = BoxTheme;
exports.default = _default;